import React from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Dialog from "@material-ui/core/Dialog";
import Moment from "react-moment";
import MyButton from "./MyButton";
import "./mapview.css";

class SuKienChiTietOverlay extends React.Component {
  constructor(props) {
    super(props);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleOK = this.handleOK.bind(this);
    this.state = {};
  }
  componentDidMount() {}
  static getDerivedStateFromProps(props, state) {
    return state;
  }
  handleCancel = () => {
    this.props.callback(false);
  };
  handleOK = () => {
    this.props.callback(true);
  };
  render() {
    const { classes, theme } = this.props;
    const data = this.props.feature.get("data");
    return (
      <React.Fragment>
        <div className="sukienOverlay sukienOverlay-measure">
          <div className='closeX' onClick={() => this.props.callback('close')}>
            X
          </div>
          <div>
            <strong>{data.TenSK}</strong>
          </div>
          <div>
            * Bị nạn:{" "}
            <Moment format="DD-MM-yyyy HH:mm:ss">{data.ThoiGianBiNan}</Moment>
          </div>
          <div>
            * {data.TenTaiNan}
          </div>
          <div style={{ maxWidth: 350}}>
            <pre className='preOVerlay'>
            * {data.TomTat}
            </pre>
          </div>
          <div>
            <a href='#' onClick={()=>this.props.callback('chitiet')} >Chi tiết</a>
            <span>  </span>
            <a href='#' onClick={()=>this.props.callback('sar')} >{'    '} Tàu SAR</a>
          </div>

        </div>
      </React.Fragment>
    );
  }
}
const styles = (theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  closeX: {

  },
  form: {
    display: "flex",
    flexDirection: "column",
    margin: "auto",
    width: "fit-content",
    heigh: "fit-content",
  },
  formControl: {
    marginTop: 2,
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: 1,
  },
  paper: {},
  textField: {
    marginLeft: 1,
    marginRight: 1,
    width: 250,
  },
});
export default withStyles(styles, { withTheme: true })(SuKienChiTietOverlay);
